//Menu click Changes
document.querySelectorAll('.menu-mobile__nav-item').forEach(item => {
  item.addEventListener('click', function (e) {
    if (e.target.closest('.mm-nav__links-header')) {
      this.classList.remove('active');
      return;
    }
    document.querySelectorAll('.menu-mobile__nav-item.active')
      .forEach(el => el.classList.remove('active'));

    this.classList.add('active');
  });
});


document.addEventListener("DOMContentLoaded", function () {

  const header = document.querySelector(".bwp-header.header_2");
  const homeLogo = document.querySelector(".header-logo_img.logo-home");
  const mainLogo = document.querySelector(".header-logo_img.logo-main");

  if (!header || !homeLogo || !mainLogo) return;

  // Desktop hover only
  if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {

    header.addEventListener("mouseenter", () => {
      if (header.classList.contains("sticky")) {
        homeLogo.style.display = "block";
        mainLogo.style.display = "none";
      }
    });

    header.addEventListener("mouseleave", () => {
      if (header.classList.contains("sticky")) {
        homeLogo.style.display = "none";
        mainLogo.style.display = "block";
      }
    });

  }

});

{/* <script>
document.addEventListener("DOMContentLoaded", function () {

  const header = document.querySelector(".bwp-header.header_2");
  const logo = document.querySelector(".header-logo_img");

  if (!header || !logo) return;

  const normalLogo = logo.src; // current white logo
  const blackLogo = "https://cdn.shopify.com/s/files/1/0920/4278/9139/files/Vilaasa-logo-design.png?v=1735296968"; 
  // 👆 yaha apna black logo URL daalna

  function toggleLogo() {
    if (header.classList.contains("sticky")) {
      logo.src = blackLogo;
    } else {
      logo.src = normalLogo;
    }
  }

  // Run on scroll
  window.addEventListener("scroll", toggleLogo);

  // Run once on load
  toggleLogo();

});
</script> */}
